import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData, LinkData } from '../../types'
import { CmsConverterService, defaultLinkData } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TopicOverviewItemConverter extends CmsConverterService<TopicOverviewItemData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      addStyle: formData.st_additional_style?.value?.identifier ?? '',
      link: {
        ...formData.st_link ?? defaultLinkData,
        text: '<p>' + formData.st_link?.text ?? '' + '</p>'
      }
    }
  }
}

export const TOPIC_OVERVIEW_ITEM_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, TopicOverviewItemData>>('TopicOverviewItemConverter')

export interface TopicOverviewItemData extends ConvertedComponentData {
  link: LinkData;
  addStyle: string;
}
